// ScrollAnimation.js
import { useEffect, useRef } from 'react';

export function useScrollAnimation() {
  const observerRef = useRef(null);
  
  useEffect(() => {
    const options = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    // 建立新的觀察者
    const createObserver = () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      
      observerRef.current = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            // 當元素離開視窗時，移除 visible 類別
            // 這樣當元素再次進入視窗時，動畫會重新觸發
            entry.target.classList.remove('visible');
          }
        });
      }, options);
      
      // 觀察所有 .appear 元素
      const elements = document.querySelectorAll('.appear');
      elements.forEach(el => {
        observerRef.current.observe(el);
      });
    };
    
    // 初始建立觀察者
    createObserver();
    
    // 使用 MutationObserver 來偵測 DOM 變化
    // 當你切換類別時，DOM 會變化，我們需要重新設置觀察者
    const mutationObserver = new MutationObserver(() => {
      createObserver();
    });
    
    mutationObserver.observe(document.querySelector('.projects-grid'), {
      childList: true, // 觀察子元素的添加或移除
      subtree: true // 觀察所有後代元素
    });
    
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      mutationObserver.disconnect();
    };
  }, []);
  
  return null;
}